import {PriorityIcon} from '@priority-software/priority-style-react';
import {texts} from './texts';
import {RuleOperators} from './components/RuleDialog/enum';
import {AlertFormFields, AlertPermission, ChatboxSpecialCategory} from './enums';

export const ruleDialogID = 'automation-rule-dialog';
export const overviewDialogID = 'automation-overview-dialog';
export const macroDialogID = 'macro-rule-dialog';

export const autofillActionId = 455;
export enum BusinessRuleAction {
    ErrorMsg = 350,
    WarningMsg = 351,
    EmailMsg = 352,
    TextMsg = 353,
    AssignTo = 354,
    AllowStatusChange = 355,
    ChangeStatusTo = 356,
    OpenTask = 358,
    PushNotification = 359,
    Webhook = 360,
    UserVerification = 361
}

export const businessRulesActionMap = {
    [BusinessRuleAction.AssignTo]: {
        icon: PriorityIcon.assignment,
        fieldsSupport: {
            supportRecipients: true
        }
    },
    [BusinessRuleAction.AllowStatusChange]: {
        icon: PriorityIcon.pending,
        fieldsSupport: {
            supportRecipients: true
        }
    },
    [BusinessRuleAction.ChangeStatusTo]: {
        icon: PriorityIcon.pending,
        fieldsSupport: {
            supportStatuses: true
        }
    },
    [BusinessRuleAction.ErrorMsg]: {
        textField: 'error_action_title',
        icon: PriorityIcon.propertyError,
        fieldsSupport: {
            supportMessage: true
        }
    },
    [BusinessRuleAction.WarningMsg]: {
        textField: 'warning_action_title',
        icon: PriorityIcon.warning,
        fieldsSupport: {
            supportMessage: true
        }
    },
    [BusinessRuleAction.EmailMsg]: {
        textField: 'send_email_action_title',
        icon: PriorityIcon.mail,
        fieldsSupport: {
            supportRecipients: true,
            supportSubject: true,
            supportMessage: true,
            supportAttachment: true,
            supportEmailEditor: true
        }
    },
    [BusinessRuleAction.TextMsg]: {
        textField: 'send_text_action_title',
        icon: PriorityIcon.chatbox,
        fieldsSupport: {
            supportRecipients: true,
            supportMessage: true,
            supportAttachment: true
        }
    },
    [BusinessRuleAction.OpenTask]: {
        textField: 'open_task_action_title',
        icon: PriorityIcon.squareCheckbox,
        fieldsSupport: {
            supportRecipients: true,
            supportSubject: true,
            supportMessage: true,
            supportAttachment: true
        }
    },
    [BusinessRuleAction.PushNotification]: {
        textField: 'send_notification_action_title',
        icon: PriorityIcon.notification,
        fieldsSupport: {
            supportRecipients: true,
            supportSubject: true,
            supportMessage: true
        }
    },
    [BusinessRuleAction.Webhook]: {
        textField: 'webhook_action_title',
        icon: PriorityIcon.new_server,
        fieldsSupport: {
            supportWebhooks: true,
            supportSubject: true,
            supportMessage: true
        }
    },
    [BusinessRuleAction.UserVerification]: {
        textField: 'user_verification_action_title',
        icon: PriorityIcon.newCheckmarkDone,
        fieldsSupport: null
    }
};

export const validForOptions = [
    {
        textField: 'myself_label',
        value: AlertFormFields.ValidMySelf,
        permission: AlertPermission.user
    },
    {
        textField: 'all_users_label',
        value: AlertFormFields.ValidAllUsers,
        permission: AlertPermission.admin
    },
    {
        textField: 'only_label',
        value: ChatboxSpecialCategory.only,
        permission: AlertPermission.admin
    }
];

export const actionStatus = [
    {
        label: texts.active_label,
        value: 1
    },
    {
        label: texts.inactive_label,
        value: 0
    }
];

export const operatorsWithValue = Object.values(RuleOperators)
    .filter(val => !isNaN(Number(val)))
    .filter(operator => {
        return !(
            operator === RuleOperators.decreases ||
            operator === RuleOperators.increases ||
            operator === RuleOperators.changes ||
            operator === RuleOperators.notBlank ||
            operator === RuleOperators.blank
        );
    }) as RuleOperators[];

export const emptyRecipientFields = {
    Webhook: undefined,
    MailType: undefined,
    RecipientField: undefined,
    RecipientGroup: [],
    RecipientMail: [],
    RecipientUser: []
};
export const messageShortcuts = {
    ruleNumber: 'Rule Number',
    ruleDesc: 'Rule Description'
};
